<template>
  <div>
    <b-card class="standardpage border-none">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="travellermetas.icon" class="mr-1"></i>
            <span>{{ travellermetas.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                  <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                    :clearable="true" :async="true" :load-options="treeselect_loadSLAC" :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Meta" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="meta" :debounce="travellermetas.debounce" placeholder="Meta"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!meta" @click="meta = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Tagname" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="tagname" :debounce="travellermetas.debounce"
                      placeholder="Tagname"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!tagname" @click="tagname = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Category" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="category" :debounce="travellermetas.debounce"
                      placeholder="Category"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!category" @click="category = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="travellermetas" :icon="travellermetas.icon"
            :busy="travellermetas.busy" :toolbarlibrary="travellermetas.toolbarlibrary" :tools="travellermetas.tools"
            :badges="travellermetas.badges" :fields="travellermetas.fields" :items="travellermetas.items"
            :limit="travellermetas.limit" :downloaded="travellermetas.downloaded" :showpages="true"
            :offset="travellermetas.offset" :page="travellermetas.page" @load="travellermetas_load"
            @click="travellermetas_click" @changed="travellermetas_click('save', $event)"
            @select="travellermetas_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="travellermetas.selected" :config="cconfig"
          @discard="travellermetas_click('discard')" @go="travellermetas_click('go')"></component>
      </div>

      <b-card-footer class="mt-2 ml-1">
        <div class="text-center">
          <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
            <i class="fa fa-cogs mr-2"></i>Setup All
          </b-button>
        </div>
      </b-card-footer>

    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import TravellerMetaTagEdit from "./Components/Setup_TravellerMetaTagEdit";

export default {
  name: "TravellerMetaTags",
  components: { TravellerMetaTagEdit },
  watch: {
    async slac() {
      await this.travellermetas_load(0);
    },
    async meta() {
      await this.travellermetas_load(0);
    },
    async tagname() {
      await this.travellermetas_load(0);
    },
    async category() {
      await this.travellermetas_load(0);
    },
  },
  data() {
    return {
      meta: null,
      slac: null,
      tagname: null,
      category: null,
      travellermetas: {
        title: "Traveller Meta Tags",
        icon: "fa fa-list",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,download,clipboard,add,edit,deleteconfirm",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
          },
          {
            key: "surname",
            label: "Surname",
            sortable: true,
          },
          {
            key: "firstname",
            label: "First Name",
            sortable: true,
          },
          {
            key: "ref",
            label: "Ref",
            sortable: true,
          },

          {
            key: "meta",
            label: "Meta",
            sortable: true,
          },
          {
            key: "tagname",
            label: "Tag Name",
            sortable: true,
          },
          {
            key: "category",
            label: "Category",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();
    await this.travellermetas_load();
  },

  methods: {
    accessdenied() {
      this.travellermetas.denied = [];
      if (!this.user.permissions.includes("setup_travellermetatags.admin")) {
        this.travellermetas.denied.push("deleteconfirm");
      }
      if (!this.user.permissions.includes("setup_travellermetatags.admin")) {
        this.travellermetas.denied.push("add");
        this.travellermetas.denied.push("save");
      }

    },
    async travellermetas_load(offset, limit, page) {
      let state = this.travellermetas;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,

        slac: this.slac,
        meta: this.meta,
        tagname: this.tagname,
        category: this.category,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_travellermetas(
              $limit: Int
              $offset: Int
              $slac: String
              $meta: String
              $tagname: String
              $category: String
              $dateformat: String
            ) {
              setup_travellermetas(
                limit: $limit
                offset: $offset
                slac: $slac
                meta: $meta
                tagname: $tagname
                category: $category
                dateformat: $dateformat
              ) {
                id
                slac
                firstname
                surname
                ref
                meta
                tagname
                category
                rows
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        // USE LOCAL VARIABLE     

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.setup_travellermetas
        } else {
          state.items = response.data.setup_travellermetas;
        }

      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async travellermetas_click(a, ss) {

      let state = this.travellermetas;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.travellermetas_load(0, 0);
          break;
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          await this.travellermetas_load();
          break;
        case "go":
          this.component = null;
          await this.travellermetas_load();
          break;
        case "add":
        case "edit":
          this.component = "TravellerMetaTagEdit";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async travellermetas_select(ss, tools) {

      let state = this.travellermetas;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {
      // let requirement = { ...this.requirement_travellermetas };


      // let requirements = "";
      // for (var prop in requirement) {
      //   if (this.item[prop] == null) {
      //     requirements += requirement[prop] + ", ";
      //     // break;
      //   }
      // }
      // if (requirements.length > 0) {
      //   this.message =
      //     "<span class='text-danger'>" +
      //     requirements.slice(0, -1) +
      //     " required field(s). </span>";
      //   return;
      // }
      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation setup_travellermetas_save(
              $rows: [setup_travellermeta_input]
              $dateformat: String
            ) {
              setup_travellermetas_save(rows: $rows, dateformat: $dateformat) {
                id
                slac
                firstname
                surname
                ref
                meta
                tagname
                category
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation setup_travellermetas_delete(
              $rows: [setup_travellermeta_input]
            ) {
              setup_travellermetas_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.travellermetas_load(0);
    },
  },
};
</script>

<style></style>